<template>
  <v-row style="height: calc( 100vh - 64px );overflow:hidden">
    <v-col cols="3"
      class="pa-0 task-card"
      absolute
      style="border-right:1px solid #1976d2;height:100%;position:relative;min-width:400px">
      <v-toolbar dense>
        <v-icon class="mr-2">mdi-clock</v-icon>
        <v-toolbar-title>Duration {{ totalDuration() }}</v-toolbar-title>
      </v-toolbar>

      <v-row style="height: calc( 100% - 96px );overflow:hidden">
        <v-col
          name="dropZone"
          class="drop-zone ml-6 mx-3 py-3"
          style="overflow:hidden auto;height:100%;position:relative;"
          @drop="onDrop($event)"
          @dragover.prevent
          @dragenter.prevent>

          <div v-if="mouseOver" style="position:absolute;top:calc( 50% - 40px);left: calc( 50% - 20px);">
            <v-btn icon>
              <v-icon size="80px">mdi-cog</v-icon>
            </v-btn>
          </div>

          <draggable
            class="list-group"
            v-model="workoutTasks"
            v-bind="dragOptions"
            @start="sortDrag = true"
            @end="sortDrag = false"
            group="tasks"
          >
            <transition-group type="transition" :name="!drag ? 'flip-list' : null">
              <div v-for="(task, id) in workoutTasks" :key="id">
                    <Task 
                      :id="id"
                      :icon="`/img/tasks/${task.category}/${task.id}.jpg`"
                      type="workout"
                      :name="task.name"
                      v-on:remove-task="removeTask(id)"
                      draggable
                      v-on:deactivate-task="deactivateTask(id, arguments[0])"/>
                </div>
            </transition-group>
          </draggable>

        </v-col>

      </v-row>

      <v-toolbar dense bottom absolute style="width:100%;">
        <v-spacer></v-spacer>
        <v-btn text
          :disabled="workoutTasks.length <= 0"
          @click="startWorkout">
          <v-icon class="mr-2">mdi-clock</v-icon>
          START
        </v-btn>
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-col>

    <v-col
      class="px-0"
      style="overflow: hidden auto;
        height: 100%;">

      <div v-for="(item, id) in categoriesList()"
        :key="`category-${item.id}`">
        <!-- CATEGORY  -->
        <v-row class="px-3">
          <v-card-title>
            {{ categories[item.id] }}
          </v-card-title>
        </v-row>

        <v-row class="px-3 task-row">
          <v-col >
            <v-slide-group
              v-model="slide[id]"
              class="pa-4"
              active-class="info"
              show-arrows
            >
              <v-slide-item
                v-for="task in item.list"
                :key="`task_${task.id}`"
                v-slot="{ active, toggle }"
              >
                <Task
                  :id="task.id"
                  :icon="`/img/tasks/${task.category}/${task.id}.jpg`"
                  :level="task.level"
                  :parts="task.parts"
                  :description="task.description"
                  :duration="task.duration"
                  :active="active"
                  :toggle="toggle"
                  :name="task.name" 
                  v-on:add-task="addTask(task.id)"
                  draggable
                  v-on:start-drag="startDrag(arguments[0], task.id)" />
              </v-slide-item>
            </v-slide-group>
          </v-col>
        </v-row>
      </div>

    </v-col>

    <v-dialog
      v-model="dialog"
      persistent
      max-width="40%"
    >
      <v-card>
        <v-card height="20em" flat>
          <CountIn v-if="countActive"
            :id="currentTaskId"
            :active="countActive"
            :count="countCount"
            v-on:count-progress="setProgress"
            v-on:count-ended="countEnded"/>
        </v-card>

        <v-progress-linear
          v-model="workoutProgress"
        ></v-progress-linear>

        <v-card-title class="headline">
          {{ currentTask.name}}
        </v-card-title>

        <v-card-text>
          {{ currentTask.description}}
        </v-card-text>
        
        <v-card-actions>
          <v-btn
            color="green darken-1"
            text
            @click="prevTask"
          >
            Previous
          </v-btn>

          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="nextTask"
          >
            Next
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import Task from '@/components/Task'
  import CountIn from '@/components/CountIn'
  import draggable from 'vuedraggable'

  export default {
    name: 'Home',

    components: {
      Task,
      draggable,
      CountIn,
    },

    props: {
      
    },

    data: () => ({
      slide: {0: null, 1: null},
      myWorkout: [],
      workoutTasks: [
      ],
      switch1: true,
      categories: {0: 'Arme', 1: 'Oberkörper', 2: 'Unterkörper', 3: 'Beine'},
      tasks: [
        {id: 0, name: 'Brust', category: 1, level: 2, parts: ['neck', 'shoulder'], duration: 120, description: 'Blabla'},
        {id: 1, name: 'Rücken', category: 1, level: 2, parts: ['neck', 'shoulder'], duration: 120, description: 'Blabla'},
        {id: 4, name: 'Bauch', category: 2, level: 2, parts: ['neck', 'shoulder'], duration: 120, description: 'Blabla'},
        {id: 5, name: 'Rücken', category: 2, level: 2, parts: ['neck', 'shoulder'], duration: 120, description: 'Blabla'},
        {id: 6, name: 'Po', category: 2, level: 2, parts: ['neck', 'shoulder'], duration: 120, description: 'Blabla'},
        {id: 7, name: 'Oberschenkel', category: 3, level: 2, parts: ['neck', 'shoulder'], duration: 120, description: 'Blabla'},
        {id: 2, name: 'Wade', category: 3, level: 2, parts: ['neck', 'shoulder'], duration: 120, description: 'Blabla'},
        {id: 8, name: 'Trizeps', category: 0, level: 2, parts: ['neck', 'shoulder'], duration: 120, description: 'Blabla'},
        {id: 9, name: 'Bizeps', category: 0, level: 2, parts: ['neck', 'shoulder'], duration: 120, description: 'Blabla'},
        {id: 10, name: 'Unterarm', category: 0, level: 2, parts: ['neck', 'shoulder'], duration: 120, description: 'Blabla'},
        {id: 3, name: 'Schulter', category: 0, level: 2, parts: ['neck', 'shoulder'], duration: 120, description: 'Blabla'},
      ],
      categoryTasksOne: [],
      categoryTasksTwo: [],
      drag: false,
      sortDrag: false,
      mouseOver: false,
      dialog: false,
      countActive: false,
      countCount: 3,
      currentTaskId: -1,
      currentTask: {id: -1, name: '', category: -1, level: 2, parts: [], duration: 3, description: ''},
      currentProgress: 0,
    }),

    computed: {
      dragOptions() {
        return {
          animation: 200,
          group: "description",
          disabled: false,
          ghostClass: "ghost"
        }
      },

      workoutProgress() {
        return this.currentTask.duration ? 100 / this.currentTask.duration * (this.currentTask.duration - this.currentProgress) : 0
      }
    },

    methods: {
      nextTask() {
        this.countEnded()
      },

      prevTask()  {
        if (this.currentTaskId-1 >= 0) {
          this.currentTaskId--
          this.currentTask = this.workoutTasks[this.currentTaskId]

          //this.countActive = true
          this.countCount = this.currentTask.duration
          this.currentProgress = 0
        }
      },

      setProgress(val) {
        this.currentProgress = val
      },

      countEnded() {
        //this.countActive = false
        if (this.currentTaskId+1 < this.workoutTasks.length) {
          this.currentTaskId++ 
          this.currentTask = this.workoutTasks[this.currentTaskId]

          //this.countActive = true
          this.countCount = this.currentTask.duration
          this.currentProgress = 0
        }
      },

      categoriesList() {
        return [
          {id: 0, list: this.tasks.filter(item => item.category === 0)},
          {id: 1, list: this.tasks.filter(item => item.category === 1)},
          {id: 2, list: this.tasks.filter(item => item.category === 2)},
          {id: 3, list: this.tasks.filter(item => item.category === 3)},
        ]
      },

      startDrag(evt, itemId) {
          this.drag = true
          evt.dataTransfer.dropEffect = 'copy'
          evt.dataTransfer.effectAllowed = 'copy'
          evt.dataTransfer.setData('itemID', itemId)
      },

      onDrop(evt) {
        if (!this.sortDrag) {
          const itemID = evt.dataTransfer.getData('itemID')
          const item = this.tasks.find(item => item.id == itemID)
          this.workoutTasks.push(Object.assign({active: true}, item))
        }
        this.drag = false
      },

      addTask(taskId) {
        const item = this.tasks.find(item => item.id == taskId)
        this.workoutTasks.push(Object.assign({active: true}, item))
      },

      removeTask(taskId) {
        this.workoutTasks.splice(taskId, 1)
      },

      deactivateTask(taskId, active) {
        this.workoutTasks[taskId].active = active
      },

      totalDuration() {
        let duration = 0
        for (let task of this.workoutTasks) {
          if (task.active) {
            duration += task.duration
          }
        }

        return duration
      },

      showDropzone() {
        this.mouseOver = (this.drag ? true : false)
      },

      startWorkout() {
        this.dialog = true
        this.countActive = true
      },
    },

    created() {
      this.categoryTasksOne = this.tasks.filter(item => item.category === 1)
      this.categoryTasksTwo = this.tasks.filter(item => item.category === 2)
    }
  }
</script>

<style scoped>

</style>

<style>
  html {
    overflow: hidden;
  }
</style>